import { render, staticRenderFns } from "./icons.vue?vue&type=template&id=b3188872&"
import script from "./icons.vue?vue&type=script&lang=js&"
export * from "./icons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports